import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/** Inklapbare sectiekaart — zelfde stijl als PendingListingsPanel.
 *  Keuze wordt per sectie onthouden via localStorage (storageKey). */
export function CollapsibleCard({ storageKey, title, icon, badge, extra, defaultOpen = false, children, testId }) {
    const [open, setOpen] = useState(() => {
        const v = localStorage.getItem(storageKey);
        return v === null ? defaultOpen : v === "1";
    });
    const toggle = () => setOpen((v) => { localStorage.setItem(storageKey, v ? "0" : "1"); return !v; });
    return (
        <section className="bg-white border border-zinc-200 rounded-sm" data-testid={testId}>
            <header
                className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 cursor-pointer select-none hover:bg-zinc-50 transition-colors"
                onClick={toggle}
                data-testid={`${testId}-toggle`}
            >
                <div className="flex items-center gap-2 min-w-0">
                    {icon}
                    <h2 className="font-display text-sm font-bold uppercase tracking-[0.14em] truncate">{title}</h2>
                    {badge != null && badge !== 0 && (
                        <span className="inline-flex items-center justify-center min-w-6 h-6 px-1.5 rounded-sm bg-[#E5A93D]/15 text-[#9A6E1B] text-xs font-bold">{badge}</span>
                    )}
                    {extra}
                    {!open && <span className="hidden sm:inline text-xs text-zinc-400 ml-1">— klik om te openen</span>}
                </div>
                <span className="inline-flex items-center justify-center h-8 w-8 rounded-sm border border-zinc-200 text-zinc-500 shrink-0">
                    <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
                </span>
            </header>
            {open && <div className="border-t border-zinc-200 p-4">{children}</div>}
        </section>
    );
}

export default CollapsibleCard;
